export const INFINITE_SCROLL_CONFIG_TYPES = {
  INFINITE_SCROLL_ENABLED: 'INFINITE_SCROLL_ENABLED',
  INFINITE_SCROLL_DISABLED: 'INFINITE_SCROLL_DISABLED'
};
export const infiniteScrollDisabled = {
  type: INFINITE_SCROLL_CONFIG_TYPES.INFINITE_SCROLL_DISABLED
};
export function isInfiniteScrollEnabled(config) {
  return config.type === INFINITE_SCROLL_CONFIG_TYPES.INFINITE_SCROLL_ENABLED;
}